import { docodeHexResponse } from '../../_common/common.utils';
import SavingsFollowupReportActionTypes from './savings-followup.types';

const INITIAL_STATE = {
	// GET SAVINGS FOLLOWUP REPORT RESPONSE
	getSavingsFollowupReportResponse: null,
	getSavingsFollowupReportArr: [],
};

const savingsFollowupReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ********************* START GET SAVINGS FOLLOWUP REPORT DETAILS ******************** */
		case SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_SUCCESS:
			return {
				...state,
				getSavingsFollowupReportResponse: action.payload,
				getSavingsFollowupReportArr: docodeHexResponse(
					action.payload,
					'GetSavingsFollowUpReportKey',
				),
			};

		case SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_FAILURE:
			return {
				...state,
				getSavingsFollowupReportResponse: action.payload,
			};

		case SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_RESPONSE_CHANGED:
			return {
				...state,
				getSavingsFollowupReportResponse: null,
			};
		/** ********************* END GET SAVINGS FOLLOWUP REPORT DETAILS ******************** */
		default:
			return state;
	}
};

export default savingsFollowupReportReducer;
